import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router/src/interfaces";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./auth.service";
import { AppCommonService } from "./appcommon.service";
import { debug } from "util";

@Injectable()
export class AuthGuard implements CanActivate{
    constructor(private authService: AuthService,private router: Router, private appCommonService: AppCommonService)
    {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.checkLoggedIn(state.url);
    }

    checkLoggedIn(url: string): boolean {
        if (!this.authService.isLoggedIn()) {            
            this.router.navigate(['/']);
            this.appCommonService.reDirectURL = url;
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts